export default "__VITE_ASSET__ColQDHN1__"